import { render, staticRenderFns } from "./mechanismDetails.vue?vue&type=template&id=366856f8&scoped=true&"
import script from "./mechanismDetails.vue?vue&type=script&lang=js&"
export * from "./mechanismDetails.vue?vue&type=script&lang=js&"
import style0 from "./mechanismDetails.vue?vue&type=style&index=0&id=366856f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366856f8",
  null
  
)

export default component.exports